








































































































































































































































































































































import Element from 'element-ui'
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { UnitProtectPlanData, emptyData, getInfo } from '@/api/heritageUnit/unitProtectPlan'
import hspGallery from '@/components/upload/gallery.vue'
import singleFile from '@/components/upload/singleFile.vue'
import ViewDialog from '@/components/dialog/viewDialog.vue'

@Component({
  components: { ViewDialog, hspGallery, singleFile }
})
export default class UnitProtectPlanView extends Vue {
  public name = 'UnitProtectPlanView'
  public showDialog: boolean = false

  public expandNames: string[] = ['base']//, 'protection', 'monitoring', 'oneLevel', 'twoLevel', 'threeLevel']
  public loading: boolean = false
  public form: UnitProtectPlanData = Object.assign({}, emptyData)
  public $refs!: {
    formData: Element.Form
    sfText: singleFile
    sfDrawing: singleFile
    gyAssessment: hspGallery
    gyPicture: hspGallery
  }
  get yearMonth(): string {
    const f = this.form
    var data = ''
    if (f.PlanYear > 0 && f.PlanMonth > 0) {
      data = f.PlanYear.toString() + '年' + f.PlanMonth.toString() + '月'
    }
    return data
  }
  public created() {
  }
  public mounted() {
    window.eventBus.$on("viewUnitProtectPlan", (id: number) => {
      this.showDialog = true
      this.fetchData(id)
    })
  }
  public beforeDestroy() {
    window.eventBus.$off("viewUnitProtectPlan")
  }
  public closeDialog() {
    this.showDialog = false
  }
  public fetchData(id: number) {
    this.form = Object.assign({}, emptyData)
    this.loading = true
    getInfo(id).then((response: { data: any }) => {
      this.form = response.data
      this.loading = false
    }).catch((error: any) => {
      console.log(error)
    })
  }
}
